<template>
  <div>
    <b-card header="Default">
      <div slot="header">{{ $lang.interviewLang.add_interview_for_time }}</div>
      <div class="text-center" v-if="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <interviewLocationPersonForm
        mode="add"
        v-if="!isLoading"
        isModal
        visbale="true"
        @modal-end-up="afterSave"
        @submit="save"
        @closeModal="closeModal"
      />
    </b-card>
  </div>
</template>

<script>
import interviewLocationPersonForm from "./../forms/interviewLocationPersonForm";
export default {
  components: {
    interviewLocationPersonForm,
  },
  props: {
    query: Object,
  },
  name: "add-interview-location-person",
  inject: ["interviewLocationPersonRepository"],
  data() {
    return {
      isLoading: false,
      attachmentId: null,
      id: this.$route.params.id,
    };
  },
  methods: {
    afterSave() {
      this.$emit("modal-end-up");
    },
    closeModal() {
      this.$emit("closeModal");
    },

    async save(payload) {
      this.isLoading = true;
      try {
        let response = await this.interviewLocationPersonRepository.create(
          payload
        );
        this.$notify.success(response.data.message);
        this.closeModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
        this.$emit("refreshData");
      }
    },
  },
};
</script>
